import React from 'react';
import './ChefSection.css';

const ChefSection = () => {
    return (
        <section className="chef-section">
            <div className="container chef-container">
                <div className="chef-image-wrapper">
                    <div className="chef-image-frame">
                        <img
                            src="/images/image.png"
                            alt="Cédric Millet et Coline Brossard - Artisans Pâtissiers"
                            className="chef-portrait"
                        />
                        <div className="frame-border"></div>
                    </div>
                </div>

                <div className="chef-content">
                    <span className="chef-subtitle">Nos Artisans</span>
                    <h2 className="chef-title">L'Audace & La Maîtrise</h2>
                    <div className="chef-divider"></div>

                    <p className="chef-description">
                        De l'audace et de la maîtrise. C'est ce qui définit le duo formé par <strong>Cédric Millet et Coline Brossard</strong>. Riches d'un parcours de quinze ans au sein des plus grandes tables étoilées, ils ont choisi la chaleur d'Albi pour partager leur passion.
                    </p>

                    <p className="chef-philosophy">
                        "Notre signature ? Une technique de haute volée au service d'une pâtisserie vivante. Nous bousculons les codes en désucrant pour laisser parler le fruit et l'épice. Une promesse : vous faire redécouvrir le vrai goût des choses."
                    </p>

                    <div className="chef-signature-container">
                        <p className="chef-signature-text">C. Millet & C. Brossard</p>
                        <span className="chef-role">Maîtres Artisans Pâtissiers</span>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ChefSection;
